// pages/Projects.js
import React from "react";
import { useLocation } from "react-router-dom";
import useAnimation from "../components/useAnimation";
import PageEnterOverlay from "../components/PageEnterOverlay";
import ProjectsSection from "../components/sections/ProjectsSection";

const Projects = () => {
  const location = useLocation();
  const { isAnimating, animationMode } = useAnimation(
    undefined,
    location.state?.fromTransition,
  );

  return (
    <div className="relative min-h-screen">
      <div className="fixed inset-0 bg-deep -z-10" />
      <PageEnterOverlay
        show={isAnimating}
        mode={animationMode}
        direction="left"
        bgClass="bg-lightBrown"
      />
      <ProjectsSection />
    </div>
  );
};

export default Projects;
